import { useExperimentFlag } from './useExperimentFlag';

export const useExperimentAdditionalProductsCheckoutInfo = (): boolean =>
    useExperimentFlag('enable_additional_products_checkout_info');
